<template>
  <div>
    <section class="photoList list10senNew_01 specialGifu">
      <div class="inner2">
        <div class="stage" v-if="winningWorks[0] || winningWorks[1]">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[0], verticalM: !isHorizontal[0] }" v-if="winningWorks[0]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[0])"><img class="exhPhotoImg" :src="(winningWorks[0].imageUrlS)" alt="" @load="(event) => loadHandler(event, 0)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[0].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[0].photographer}}</p>
              <ul v-if="isCommentaryExists(0)" class="photoCommentary" style="height: 27px;">
                <li v-if="isCommentExists(0)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[0], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(0)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[0], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
                <!-- 1枚目の画像には音声データ無し
                <li v-if="voiceButton[0]" @click="changeVoiceButton(0)" class="expTxtBtn sp"><img class="" src="/img2021/expAudioOn.png" srcset="/img2021/expAudioOn@2x.png 2x" alt="音声ガイド" /></li>
                <li v-else @click="changeVoiceButton(0)" class="expTxtBtn sp"><img class="" src="/img2021/expAudio.png" srcset="/img2021/expAudio@2x.png 2x" alt="音声ガイド" /></li>
                -->
              </ul>
              <!-- 1枚目の画像には音声データ無し
              <div class="pc">
                <div class="audioCtrl">
                  <img class="" src="/img2021/expAudioHead.png" srcset="/img2021/expAudioHead@2x.png 2x" alt="" />
                  <audio controlslist="nodownload" controls style="height: 24px;" />
                </div>
              </div>
              -->
            </div><!-- /exhPhotoInfo-->
          </section>
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[1], verticalM: !isHorizontal[1] }" v-if="winningWorks[1]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[1])"><img class="exhPhotoImg" :src="(winningWorks[1].imageUrlS)" alt="" @load="(event) => loadHandler(event, 1)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[1].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[1].photographer}}</p>
              <ul v-if="isCommentaryExists(1)" class="photoCommentary" style="height: 27px;">
                <li v-if="isCommentExists(1)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[1], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(1)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[1], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
                <!-- 2枚目の画像には音声データ無し
                <li v-if="voiceButton[1]" @click="changeVoiceButton(1)" class="expTxtBtn sp"><img class="" src="/img2021/expAudioOn.png" srcset="/img2021/expAudioOn@2x.png 2x" alt="音声ガイド" /></li>
                <li v-else @click="changeVoiceButton(1)" class="expTxtBtn sp"><img class="" src="/img2021/expAudio.png" srcset="/img2021/expAudio@2x.png 2x" alt="音声ガイド" /></li>
                -->
              </ul>
              <!-- 2枚目の画像には音声データ無し
              <div class="pc">
                <div class="audioCtrl">
                  <img class="" src="/img2021/expAudioHead.png" srcset="/img2021/expAudioHead@2x.png 2x" alt="" />
                  <audio controlslist="nodownload" controls :src="`${audioUrl}${winner.id}/${winningWorks[1].id}.mp3`" style="height: 24px;" />
                </div>
              </div>
              -->
            </div><!-- /exhPhotoInfo-->
          </section>
        </div><!-- /stage-->
        <div class="audioCtrl sp">
          <audio controlslist="nodownload" v-if="audioCtrlUi[0]" controls style="height: 24px; width: 85%;" />
          <audio controlslist="nodownload" v-else-if="audioCtrlUi[1]" :src="`${audioUrl}${winner.id}/${winningWorks[1].id}.mp3`" controls style="height: 24px; width: 85%;" />
        </div>


        <div class="stage" v-if="winningWorks[2] || winningWorks[3]">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[2], verticalM: !isHorizontal[2] }" v-if="winningWorks[2]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[2])"><img class="exhPhotoImg" :src="(winningWorks[2].imageUrlS)" alt="" @load="(event) => loadHandler(event, 2)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[2].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[2].photographer}}</p>
              <ul v-if="isCommentaryExists(2)" class="photoCommentary">
                <li v-if="isCommentExists(2)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[2], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(2)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[2], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
                <li v-if="voiceButton[2]" @click="changeVoiceButton(2)" class="expTxtBtn sp"><img class="" src="/img2021/expAudioOn.png" srcset="/img2021/expAudioOn@2x.png 2x" alt="音声ガイド" /></li>
                <li v-else @click="changeVoiceButton(2)" class="expTxtBtn sp"><img class="" src="/img2021/expAudio.png" srcset="/img2021/expAudio@2x.png 2x" alt="音声ガイド" /></li>
              </ul>
              <div class="pc">
                <div class="audioCtrl">
                  <img class="" src="/img2021/expAudioHead.png" srcset="/img2021/expAudioHead@2x.png 2x" alt="" />
                  <audio controlslist="nodownload" controls :src="`${audioUrl}${winner.id}/${winningWorks[2].id}.mp3`" style="height: 24px;" />
                </div>
              </div>
            </div><!-- /exhPhotoInfo-->
          </section>
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[3], verticalM: !isHorizontal[3] }" v-if="winningWorks[3]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[3])"><img class="exhPhotoImg" :src="(winningWorks[3].imageUrlS)" alt="" @load="(event) => loadHandler(event, 3)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[3].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[3].photographer}}</p>
              <ul v-if="isCommentaryExists(3)" class="photoCommentary" style="height: 27px;">
                <li v-if="isCommentExists(3)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[3], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(3)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[3], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
                <!-- 3枚目の画像には音声データ無し
                <li v-if="voiceButton[3]" @click="changeVoiceButton(3)" class="expTxtBtn sp"><img class="" src="/img2021/expAudioOn.png" srcset="/img2021/expAudioOn@2x.png 2x" alt="音声ガイド" /></li>
                <li v-else @click="changeVoiceButton(3)" class="expTxtBtn sp"><img class="" src="/img2021/expAudio.png" srcset="/img2021/expAudio@2x.png 2x" alt="音声ガイド" /></li>
                -->
              </ul>
              <!-- 3枚目の画像には音声データ無し
              <div class="pc">
                <div class="audioCtrl">
                  <img class="" src="/img2021/expAudioHead.png" srcset="/img2021/expAudioHead@2x.png 2x" alt="" />
                  <audio controlslist="nodownload" controls :src="`${audioUrl}${winner.id}/${winningWorks[3].id}.mp3`" style="height: 24px;" />
                </div>
              </div>
              -->
            </div><!-- /exhPhotoInfo-->
          </section>
        </div><!-- /stage-->
        <div class="audioCtrl sp">
          <audio controlslist="nodownload" v-if="audioCtrlUi[2]" controls :src="`${audioUrl}${winner.id}/${winningWorks[2].id}.mp3`" style="height: 24px; width: 85%;" />
          <audio controlslist="nodownload" v-else-if="audioCtrlUi[3]" controls :src="`${audioUrl}${winner.id}/${winningWorks[3].id}.mp3`" style="height: 24px; width: 85%;" />
        </div>

        <div class="stage" v-if="winningWorks[4] || winningWorks[5]">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[4], verticalM: !isHorizontal[4] }" v-if="winningWorks[4]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[4])"><img class="exhPhotoImg" :src="(winningWorks[4].imageUrlS)" alt="" @load="(event) => loadHandler(event, 4)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[4].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[4].photographer}}</p>
              <ul v-if="isCommentaryExists(4)" class="photoCommentary">
                <li v-if="isCommentExists(4)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[4], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(4)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[4], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
                <li v-if="voiceButton[4]" @click="changeVoiceButton(4)" class="expTxtBtn sp"><img class="" src="/img2021/expAudioOn.png" srcset="/img2021/expAudioOn@2x.png 2x" alt="音声ガイド" /></li>
                <li v-else @click="changeVoiceButton(4)" class="expTxtBtn sp"><img class="" src="/img2021/expAudio.png" srcset="/img2021/expAudio@2x.png 2x" alt="音声ガイド" /></li>
              </ul>
              <div class="pc">
                <div class="audioCtrl">
                  <img class="" src="/img2021/expAudioHead.png" srcset="/img2021/expAudioHead@2x.png 2x" alt="" />
                  <audio controlslist="nodownload" controls :src="`${audioUrl}${winner.id}/${winningWorks[4].id}.mp3`" style="height: 24px;" />
                </div>
              </div>
            </div><!-- /exhPhotoInfo-->
          </section>
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[5], verticalM: !isHorizontal[5] }" v-if="winningWorks[5]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[5])"><img class="exhPhotoImg" :src="(winningWorks[5].imageUrlS)" alt="" @load="(event) => loadHandler(event, 5)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[5].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[5].photographer}}</p>
              <ul v-if="isCommentaryExists(5)" class="photoCommentary">
                <li v-if="isCommentExists(5)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[5], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(5)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[5], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
                <li v-if="voiceButton[5]" @click="changeVoiceButton(5)" class="expTxtBtn sp"><img class="" src="/img2021/expAudioOn.png" srcset="/img2021/expAudioOn@2x.png 2x" alt="音声ガイド" /></li>
                <li v-else @click="changeVoiceButton(5)" class="expTxtBtn sp"><img class="" src="/img2021/expAudio.png" srcset="/img2021/expAudio@2x.png 2x" alt="音声ガイド" /></li>
              </ul>
              <div class="pc">
                <div class="audioCtrl">
                  <img class="" src="/img2021/expAudioHead.png" srcset="/img2021/expAudioHead@2x.png 2x" alt="" />
                  <audio controlslist="nodownload" controls :src="`${audioUrl}${winner.id}/${winningWorks[5].id}.mp3`" style="height: 24px;" />
                </div>
              </div>
            </div><!-- /exhPhotoInfo-->
          </section>
        </div><!-- /stage-->
        <div class="audioCtrl sp">
          <audio controlslist="nodownload" v-if="audioCtrlUi[4]" controls :src="`${audioUrl}${winner.id}/${winningWorks[4].id}.mp3`" style="height: 24px; width: 85%;" />
          <audio controlslist="nodownload" v-else-if="audioCtrlUi[5]" controls :src="`${audioUrl}${winner.id}/${winningWorks[5].id}.mp3`" style="height: 24px; width: 85%;" />
        </div>

        <div class="stage" v-if="winningWorks[6] || winningWorks[7]">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[6], verticalM: !isHorizontal[6] }" v-if="winningWorks[6]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[6])"><img class="exhPhotoImg" :src="(winningWorks[6].imageUrlS)" alt="" @load="(event) => loadHandler(event, 6)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[6].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[6].photographer}}</p>
              <ul v-if="isCommentaryExists(6)" class="photoCommentary" style="height: 27px;">
                <li v-if="isCommentExists(6)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[6], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(6)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[6], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
                <!-- 7枚目の画像には音声データ無し
                <li v-if="voiceButton[6]" @click="changeVoiceButton(6)" class="expTxtBtn sp"><img class="" src="/img2021/expAudioOn.png" srcset="/img2021/expAudioOn@2x.png 2x" alt="音声ガイド" /></li>
                <li v-else @click="changeVoiceButton(6)" class="expTxtBtn sp"><img class="" src="/img2021/expAudio.png" srcset="/img2021/expAudio@2x.png 2x" alt="音声ガイド" /></li>
                -->
              </ul>
              <!-- 7枚目の画像には音声データ無し
              <div class="pc">
                <div class="audioCtrl">
                  <img class="" src="/img2021/expAudioHead.png" srcset="/img2021/expAudioHead@2x.png 2x" alt="" />
                  <audio controlslist="nodownload" controls :src="`${audioUrl}${winner.id}/${winningWorks[6].id}.mp3`" style="height: 24px;" />
                </div>
              </div>
              -->
            </div><!-- /exhPhotoInfo-->
          </section>
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[7], verticalM: !isHorizontal[7] }" v-if="winningWorks[7]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[7])"><img class="exhPhotoImg" :src="(winningWorks[7].imageUrlS)" alt="" @load="(event) => loadHandler(event, 7)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[7].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[7].photographer}}</p>
              <ul v-if="isCommentaryExists(7)" class="photoCommentary" style="height: 27px;">
                <li v-if="isCommentExists(7)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[7], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(7)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[7], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
                <!-- 8枚目の画像には音声データ無し
                <li v-if="voiceButton[7]" @click="changeVoiceButton(7)" class="expTxtBtn sp"><img class="" src="/img2021/expAudioOn.png" srcset="/img2021/expAudioOn@2x.png 2x" alt="音声ガイド" /></li>
                <li v-else @click="changeVoiceButton(7)" class="expTxtBtn sp"><img class="" src="/img2021/expAudio.png" srcset="/img2021/expAudio@2x.png 2x" alt="音声ガイド" /></li>
                -->
              </ul>
              <!-- 8枚目の画像には音声データ無し
              <div class="pc">
                <div class="audioCtrl">
                  <img class="" src="/img2021/expAudioHead.png" srcset="/img2021/expAudioHead@2x.png 2x" alt="" />
                  <audio controlslist="nodownload" controls :src="`${audioUrl}${winner.id}/${winningWorks[7].id}.mp3`" style="height: 24px;" />
                </div>
              </div>
              -->
            </div><!-- /exhPhotoInfo-->
          </section>
        </div><!-- /stage-->
        <div class="audioCtrl sp">
          <audio controlslist="nodownload" v-if="audioCtrlUi[6]" :src="`${audioUrl}${winner.id}/${winningWorks[6].id}.mp3`" controls style="height: 24px; width: 85%;" />
          <audio controlslist="nodownload" v-else-if="audioCtrlUi[7]" controls style="height: 24px; width: 85%;" />
        </div>

        <div class="stage" v-if="winningWorks[8] || winningWorks[9]">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[8], verticalM: !isHorizontal[8] }" v-if="winningWorks[8]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[8])"><img class="exhPhotoImg" :src="(winningWorks[8].imageUrlS)" alt="" @load="(event) => loadHandler(event, 8)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[8].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[8].photographer}}</p>
              <ul v-if="isCommentaryExists(8)" class="photoCommentary">
                <li v-if="isCommentExists(8)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[8], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(8)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[8], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
                <!-- 9枚目の画像には音声データ無し
                <li v-if="voiceButton[8]" @click="changeVoiceButton(8)" class="expTxtBtn sp"><img class="" src="/img2021/expAudioOn.png" srcset="/img2021/expAudioOn@2x.png 2x" alt="音声ガイド" /></li>
                <li v-else @click="changeVoiceButton(8)" class="expTxtBtn sp"><img class="" src="/img2021/expAudio.png" srcset="/img2021/expAudio@2x.png 2x" alt="音声ガイド" /></li>
                -->
              </ul>
              <!-- 9枚目の画像には音声データ無し
              <div class="pc">
                <div class="audioCtrl">
                  <img class="" src="/img2021/expAudioHead.png" srcset="/img2021/expAudioHead@2x.png 2x" alt="" />
                  <audio controlslist="nodownload" controls :src="`${audioUrl}${winner.id}/${winningWorks[8].id}.mp3`" style="height: 24px;" />
                </div>
              </div>
              -->
            </div><!-- /exhPhotoInfo-->
          </section>
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[9], verticalM: !isHorizontal[9] }" v-if="winningWorks[9]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[9])"><img class="exhPhotoImg" :src="(winningWorks[9].imageUrlS)" alt="" @load="(event) => loadHandler(event, 9)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[9].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[9].photographer}}</p>
              <ul v-if="isCommentaryExists(9)" class="photoCommentary">
                <li v-if="isCommentExists(9)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[9], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(9)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[9], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
                <!-- 10枚目の画像には音声データ無し
                <li v-if="voiceButton[9]" @click="changeVoiceButton(9)" class="expTxtBtn sp"><img class="" src="/img2021/expAudioOn.png" srcset="/img2021/expAudioOn@2x.png 2x" alt="音声ガイド" /></li>
                <li v-else @click="changeVoiceButton(9)" class="expTxtBtn sp"><img class="" src="/img2021/expAudio.png" srcset="/img2021/expAudio@2x.png 2x" alt="音声ガイド" /></li>
                -->
              </ul>
              <!-- 10枚目の画像には音声データ無し
              <div class="pc">
                <div class="audioCtrl">
                  <img class="" src="/img2021/expAudioHead.png" srcset="/img2021/expAudioHead@2x.png 2x" alt="" />
                  <audio controlslist="nodownload" controls :src="`${audioUrl}${winner.id}/${winningWorks[9].id}.mp3`" style="height: 24px;" />
                </div>
              </div>
              -->
            </div><!-- /exhPhotoInfo-->
          </section>
        </div><!-- /stage-->
        <div class="audioCtrl sp">
          <audio controlslist="nodownload" v-if="audioCtrlUi[8]" :src="`${audioUrl}${winner.id}/${winningWorks[8].id}.mp3`" controls style="height: 24px; width: 85%;" />
          <audio controlslist="nodownload" v-else-if="audioCtrlUi[9]" :src="`${audioUrl}${winner.id}/${winningWorks[9].id}.mp3`" controls style="height: 24px; width: 85%;" />
        </div>

        <div class="stage" v-if="winningWorks[10] || winningWorks[11]">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[10], verticalM: !isHorizontal[10] }" v-if="winningWorks[10]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[10])"><img class="exhPhotoImg" :src="(winningWorks[10].imageUrlS)" alt="" @load="(event) => loadHandler(event, 10)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[10].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[10].photographer}}</p>
              <ul v-if="isCommentaryExists(10)" class="photoCommentary">
                <li v-if="isCommentExists(10)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[10], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(10)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[10], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
                <li v-if="voiceButton[10]" class="expTxtBtn sp"><img class="" src="/img2021/expAudioOn.png" srcset="/img2021/expAudioOn@2x.png 2x" alt="音声ガイド" /></li>
                <li v-else @click="changeVoiceButton(10, 11)" class="expTxtBtn sp"><img class="" src="/img2021/expAudio.png" srcset="/img2021/expAudio@2x.png 2x" alt="音声ガイド" /></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
          </section>
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[11], verticalM: !isHorizontal[11] }" v-if="winningWorks[11]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[11])"><img class="exhPhotoImg" :src="(winningWorks[11].imageUrlS)" alt="" @load="(event) => loadHandler(event, 11)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[11].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[11].photographer}}</p>
              <ul v-if="isCommentaryExists(11)" class="photoCommentary">
                <li v-if="isCommentExists(11)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[11], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(11)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[11], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
                <li v-if="voiceButton[11]" class="expTxtBtn sp"><img class="" src="/img2021/expAudioOn.png" srcset="/img2021/expAudioOn@2x.png 2x" alt="音声ガイド" /></li>
                <li v-else @click="changeVoiceButton(11, 10)" class="expTxtBtn sp"><img class="" src="/img2021/expAudio.png" srcset="/img2021/expAudio@2x.png 2x" alt="音声ガイド" /></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
          </section>
        </div><!-- /stage-->

        <div class="stage" v-if="winningWorks[12] || winningWorks[13]">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[12], verticalM: !isHorizontal[12] }" v-if="winningWorks[12]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[12])"><img class="exhPhotoImg" :src="(winningWorks[12].imageUrlS)" alt="" @load="(event) => loadHandler(event, 12)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[12].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[12].photographer}}</p>
              <ul v-if="isCommentaryExists(12)" class="photoCommentary">
                <li v-if="isCommentExists(12)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[12], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(12)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[12], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
          </section>
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[13], verticalM: !isHorizontal[13] }" v-if="winningWorks[13]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[13])"><img class="exhPhotoImg" :src="(winningWorks[13].imageUrlS)" alt="" @load="(event) => loadHandler(event, 13)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[13].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[13].photographer}}</p>
              <ul v-if="isCommentaryExists(13)" class="photoCommentary">
                <li v-if="isCommentExists(13)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[13], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(13)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[13], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
          </section>
        </div><!-- /stage-->

        <div class="stage" v-if="winningWorks[14] || winningWorks[15]">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[14], verticalM: !isHorizontal[14] }" v-if="winningWorks[14]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[14])"><img class="exhPhotoImg" :src="(winningWorks[14].imageUrlS)" alt="" @load="(event) => loadHandler(event, 14)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[14].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[14].photographer}}</p>
              <ul v-if="isCommentaryExists(14)" class="photoCommentary">
                <li v-if="isCommentExists(14)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[14], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(14)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[14], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
          </section>
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[15], verticalM: !isHorizontal[15] }" v-if="winningWorks[15]">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[15])"><img class="exhPhotoImg" :src="(winningWorks[15].imageUrlS)" alt="" @load="(event) => loadHandler(event, 15)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[15].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[15].photographer}}</p>
              <ul v-if="isCommentaryExists(15)" class="photoCommentary">
                <li v-if="isCommentExists(15)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[15], 'comment')"><img class="" src="/img2021/expTxt.png" srcset="/img2021/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(15)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[15], 'movie')"><img class="" src="/img2021/expMovie.png" srcset="/img2021/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
          </section>
        </div><!-- /stage-->

      </div><!-- /inner-->
    </section><!-- /photoList-->
  </div>
</template>

<script>

export default {
  components: {
  },
  props: [
    'winner',
    'openImageViewer'
  ],
  data () {
    return {
      winningWorks: [],
      isHorizontal: {},
      voiceButton: [
        false, false, false, false, false, false, false, false, false, false
      ],
      audioCtrlUi: [
        false, false, false, false, false, false, false, false, false, false
      ],
      audios: [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ],
      audioUrl: process.env.VUE_APP_AUDIO_URL
    }
  },
  methods: {
    loadHandler (event, index) {
      // 縦位置横位置判定
      if (event.target.naturalWidth >= event.target.naturalHeight) {
        this.$set(this.isHorizontal, index, true)
      } else {
        this.$set(this.isHorizontal, index, false)
      }
    },
    changeVoiceButton (idx) {
      let pairIdx = idx - 1 
      if (idx % 2 === 0) {
        pairIdx = idx + 1
      }
      const flag = !this.voiceButton[idx]
      this.$set(this.voiceButton, idx, flag)
      this.$set(this.voiceButton, pairIdx, false)

      // audioCtrlUiについては、一度消して、遅延して表示する
      this.$set(this.audioCtrlUi, idx, false)
      this.$set(this.audioCtrlUi, pairIdx, false)
      setTimeout(() => {
        this.$set(this.audioCtrlUi, idx, flag)
        this.$set(this.audioCtrlUi, pairIdx, false)
      }, 100);
    },
    isCommentaryExists (index) {
      return (
        this.winningWorks[index].winningWorkIntroduction && (
          this.winningWorks[index].winningWorkIntroduction.comment ||
          this.winningWorks[index].winningWorkIntroduction.youtubeUrl
        )
      )
    },
    isCommentExists (index) {
      return (
        this.winningWorks[index].winningWorkIntroduction &&
        this.winningWorks[index].winningWorkIntroduction.comment
      )
    },
    isMovieExists (index) {
      return (
        this.winningWorks[index].winningWorkIntroduction &&
        this.winningWorks[index].winningWorkIntroduction.youtubeUrl
      )
    },
    imageUrlS (work) {
      return work.imageFile.replace('_l.jpg', '_s.jpg')
    }
  },
  created () {
    this.winningWorks = this.winner.winningWorks
    console.log('this.winningWorks', this.winningWorks)
  }
}
</script>
<style scoped>
.photoTitleSub {
  word-break:break-all;
}
</style>
